<template>
  <BasePage>
    <div class="columns is-desktop">
      <div class="column is-one-third is-offset-one-third">
        <section class="mt-4">
          <h1 class="title is-2">Create New Password</h1>

          <form action="" method="post" @submit.prevent="reset()">

            <div class="field">
              <label class="label">Password</label>
              <p class="control">
                <input
                  v-model="new_password1"
                  class="input"
                  type="password"
                  placeholder="new password"
                  required
                  />

                <p class="help is-danger" v-for="error in newPassword1Erorrs">{{ error }}</p>
              </p>
            </div>

            <div class="field">
              <label class="label">Password (Again)</label>
              <p class="control">
                <input
                  v-model="new_password2"
                  class="input"
                  type="password"
                  placeholder="new password"
                  required
                  />
                <p class="help is-danger" v-for="error in newPassword2Erorrs">{{ error }}</p>
              </p>
            </div>

            <div class="field">
              <p class="control">
                <button type='submit' class="button is-primary" :class="loading && 'is-loading'" :disabled="!valid">Create New Password</button>
              </p>
            </div>

          </form>

        </section>
      </div>
    </div>
  </BasePage>
</template>

<script>
import axios from 'axios'

import BasePage from './BasePage.vue'

import store from '../store'
export default {
  name: 'PasswordReset',
  data () {
    return {
      uid: this.$route.params.uid,
      token: this.$route.params.token,
      new_password1: '',
      new_password2: '',
      requirements: [],
      newPassword2Erorrs: [],
      newPassword1Erorrs: [],
      loading: false,
    }
  },
  components: {
    BasePage,
  },
  methods: {
    reset () {
      // TODO: refactor this into the store
      const data = {
        uid: this.uid,
        token: this.token,
        new_password1: this.new_password1,
        new_password2: this.new_password2,
      }
      this.loading = true
      axios.post('/api/v1/rest-auth/password/reset/confirm/', data)
        .then(() => {
          this.$router.push('/login')
        })
        .catch(error => {
          if (error.response) {
            const data = error.response.data
            this.newPassword2Erorrs = data.new_password2 != null ? data.new_password2 : []
            this.newPassword1Erorrs = data.new_password1 != null ? data.new_password1 : []

            const invalidToken = data.token
            if (invalidToken) {
              store.commit('notify', {
                message: 'Invalid Reset Token. It has likely been used already.',
                level: 'danger',
                sticky: true,
              })
            }
          } else {
            // network error
            store.commit('notify', {
              message: 'Error contacting server. Are you connected to the internet?',
              level: 'danger',
              sticky: true,
            })
          }
        })
        .then(() => {
          this.loading = false
        })
    },
  },
  computed: {
    valid () {
      return this.new_password1 !== '' && this.new_password2 !== ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// ConfirmPasswordReset.vue?5c9b548a